import React, { useEffect, useRef } from "react";
import ApexCharts, { ApexOptions } from "apexcharts";

type SeriesItem = {
  name?: string;
  user_name?: string;
  data: number[];
  labels: string[];
};

type RadarChartProps = {
  chart_data: SeriesItem[];
  chartSuffix?: string;
  chartHeight?: number;
};

const pastelColors = [
  "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0",
  "#546E7A", "#26A69A", "#D10CE8", "#2E93fA", "#66DA26",
  "#E91E63", "#FF9800", "#B3B3B3", "#7E57C2", "#26C6DA",
  "#FF5722", "#8D6E63", "#78909C", "#D4E157", "#455A64",
  "#F44336", "#03A9F4", "#8BC34A", "#FFEB3B", "#FF9800",
  "#9C27B0", "#CDDC39", "#673AB7", "#2196F3", "#4CAF50",
  "#FFC107", "#FF5252", "#00BCD4", "#9E9E9E", "#607D8B",
  "#C62828", "#AD1457", "#6A1B9A", "#4527A0", "#283593",
  "#0277BD", "#00838F", "#2E7D32", "#F9A825", "#FF6F00",
  "#D84315", "#4E342E", "#37474F", "#1B5E20", "#01579B"
];

const RadarChart: React.FC<RadarChartProps> = ({
  chart_data = [],
  chartSuffix = "1",
  chartHeight = 250
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null);
  const chartInstance = useRef<ApexCharts | null>(null);

  useEffect(() => {
    const labels: string[] =
      chart_data.length > 0
        ? chart_data[0].labels.map((label: string) => {
          const parts = label.trim().split(" ");
          if (parts.length > 1) {
            return `${parts[0][0]}. ${parts[1]}`;
          }
          return label;
        })
        : [];

    const options: ApexOptions = {
      series: chart_data.map((series) => ({
        name: series.user_name ?? series.name ?? "Series",
        data: series.data,
      })),
      chart: {
        type: "radar",
        height: chartHeight,
        toolbar: {
          tools: {
            download: false,
          },
        }
      },
      xaxis: {
        categories: labels,
        labels: {
          style: {
            // fontWeight: labels.map((label) =>
            //   label === "Average" ? "bold" : "normal"
            // ),
            colors: Array(labels.length).fill("#000000"),
          },
        },
      },
      stroke: {
        width: 2,
      },
      fill: {
        opacity: 0.1,
      },
      colors: pastelColors.slice(0, chart_data.length),
    };

    // Destroy previous instance
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (chartRef.current) {
      chartInstance.current = new ApexCharts(chartRef.current, options);
      chartInstance.current.render();
    }

    return () => {
      chartInstance.current?.destroy();
    };
  }, [chart_data, chartSuffix]);

  return (
    <div
      id={`radar-chart-${chartSuffix}`}
      ref={chartRef}
      style={{ width: "100%", height: "100%" }}
    />
  );
};

export default RadarChart;